const COOKIE = {
    CARE_CENTER_ID: "patientPortalCareCenterId"
};

const SESSION_STORAGE = {
    TIME_OF_REGISTRATION_START: "timeOfRegistrationStart"
};

export {COOKIE, SESSION_STORAGE};
